import { Input, Tag, Tooltip } from 'antd';

// Basic integration identity. In edit mode the template can't change (CLAUS has no re-template), so
// it renders as a read-only mono tag. The Enabled switch lives in the page header, not here.
export default function BasicSection({ name, onChangeName, templateName, type, source }) {
	const templateLabel = [type, source].filter(Boolean).join(' · ') || '—';
	return (
		<div className="ei-fgrid">
			<div className="ei-fitem">
				<span className="ei-flabel">
					Integration name <span className="ei-field-req">*</span>
				</span>
				<Input
					status={name.trim() ? undefined : 'error'}
					value={name}
					onChange={(e) => onChangeName(e.target.value)}
					placeholder="e.g. Production Greenhouse"
				/>
			</div>
			<div className="ei-fitem is-narrow">
				<span className="ei-flabel">Template</span>
				<div style={{ display: 'flex', alignItems: 'center', minHeight: 40 }}>
					<Tooltip title={templateName || undefined}>
						<Tag className="js-mono">{templateLabel}</Tag>
					</Tooltip>
				</div>
			</div>
		</div>
	);
}
